import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

export const MatchStatusCountdown = ( { match } ) => {

    const countdownRef = useRef();
    const countdownInner = useRef();
    const MILLIS = 1000;
    const countDownTimeInSeconds = ( Date.parse( match.utcStartTime ) / MILLIS );
    const countdownId = `fb-${match.id}`;

    useEffect( () => {
        countdownInner.current = new PULSE.app.Countdown( countdownRef.current );
    }, [] );

    return (
        <div className="fb-match-countdown-container" ref={countdownRef} data-countdown-to={countDownTimeInSeconds} data-countdown-id={countdownId}>
            <div className='fb-match-countdown js-countdown-here'></div>
        </div>
    );
};

MatchStatusCountdown.propTypes = {
    match: PropTypes.object
};